import React from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

export default function PrivacyPolicy() {
  return (
    <DocumentTitle title={I18n.general.privacyPolicy}>
      <Card
        style={{ margin: 32, boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.4)" }}
        title={
          <Typography.Title level={2} style={{ paddingBottom: 0, marginBottom: 0 }}>
            {I18n.general.privacyPolicy}
          </Typography.Title>
        }
      >
        <Typography.Paragraph>
          لِنا استایل ضمن احترامی که برای حریم شخصی کاربران قائل است، برای خرید،
          ثبت نظر یا استفاده از برخی امکانات وب سایت اطلاعاتی را از کاربران
          درخواست می‌کند تا بتواند خدماتی امن و مطمئن را به کاربران ارائه دهد.
          برای پردازش و ارسال سفارش، اطلاعاتی مانند آدرس و شماره تلفن مورد نیاز
          است. همچنین آدرس ایمیل و تلفن‌هایی که مشتری در پروفایل خود ثبت می‌کند،
          تنها آدرس ایمیل و تلفن‌های رسمی و مورد تایید مشتری است و تمام مکاتبات
          و پاسخ‌های شرکت از طریق آنها صورت می‌گیرد. بنابراین درج آدرس، ایمیل و
          شماره تماس‌های همراه و ثابت توسط مشتری، به منزله مورد تایید بودن صحت
          آنها است و در صورتی که این موارد به صورت صحیح یا کامل درج نشده باشد،
          لِنا استایل جهت اطمینان از صحت و قطعیت ثبت سفارش می‌تواند از مشتری،
          اطلاعات تکمیلی و بیشتری درخواست کند.
        </Typography.Paragraph>
        <Typography.Paragraph>
          مشتریان می‌توانند نام، آدرس و تلفن شخص دیگری را برای تحویل گرفتن سفارش
          وارد کنند و لِنا استایل تنها برای ارسال همان سفارش، از این اطلاعات
          استفاده خواهد کرد.
        </Typography.Paragraph>
        <Typography.Paragraph>
          همچنین لِنا استایل ممکن است برای ارتباط با مشتریان، بهینه سازی محتوای
          وب سایت و تحقیقات بازاریابی از برخی اطلاعات استفاده کند و برای اطلاع
          رسانی رویدادها و اخبار، خدمات و سرویس‌های ویژه یا پروموشن‌ها، برای
          اعضای وب سایت ایمیل یا پیامک ارسال نماید.
        </Typography.Paragraph>
        <Typography.Paragraph>
          حفظ و نگهداری رمز ورود بر عهده کاربران است و برای جلوگیری از هرگونه
          سوء استفاده احتمالی، کاربران نباید آن را برای شخص دیگری فاش کنند.
          لِنا استایل هویت شخصی کاربران را محرمانه می‌داند و اطلاعات شخصی آنان را
          به هیچ شخص یا سازمان دیگری منتقل نمی‌کند، مگر اینکه با حکم قانونی
          مجبور باشد در اختیار مراجع ذی‌صلاح قرار دهد.
        </Typography.Paragraph>
        <Typography.Paragraph>
          لِنا استایل همانند سایر وب سایت‌ها از جمع آوری IP و کوکی‌ها استفاده
          می‌کند، اما پروتکل، سرور و لایه‌های امنیتی لِنا استایل و روش‌های مناسب
          مدیریت داده‌ها اطلاعات کاربران را محافظت و از دسترسی‌های غیر قانونی
          جلوگیری می‌کند.
        </Typography.Paragraph>
      </Card>
    </DocumentTitle>
  );
}
